import { httpService } from '@/services/HttpService';

class NatService {
  getNatsForVM(workspaceId: number, regionId: number, nicId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/regions/${regionId}/nats?nic_id=${nicId}`);
  }
  getNats(workspaceId: number, regionId: number, publicIdAddress: number): Promise<any> {
    return httpService.get(
      `workspaces/${workspaceId}/regions/${regionId}/nats?public_ip_address_id=${publicIdAddress}`
    );
  }
  getAllNats(workspaceId: number, regionId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/regions/${regionId}/nats`);
  }
  createNat(workspaceId: number, regionId: number, natData: any): Promise<any> {
    return httpService.post(`workspaces/${workspaceId}/regions/${regionId}/nats`, natData);
  }
  bulkDeleteNats(workspaceId: number, regionId: number, natData: any): Promise<any> {
    return httpService.delete(`workspaces/${workspaceId}/regions/${regionId}/nats/bulk_destroy`, { nat_ids: natData });
  }
}

export const natService = new NatService();
